import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import SEO from "../components/seo"
import LayoutExtra from "../components/layoutExtra"

const CustomerHarassment = () => {
	const data = useStaticQuery(graphql`
    query {
      privacyPolicyIcon: file(relativePath: { eq: "icons/privacy-policy.svg" }) {
        publicURL
      },
    }
	`)

	return (
		<LayoutExtra>
			<SEO title="カスタマーハラスメントに対する基本方針" />
			<div className="page-head">
				<div className="h2-subtitle">
					<img src={data.privacyPolicyIcon.publicURL} alt="カスタマーハラスメントに対する基本方針" />
					<h2>カスタマーハラスメントに対する基本方針</h2>
					<p>Customer Harassment Policy</p>
				</div>
			</div>

			<p>
				当社は、「多様な知見をもとに、顧客の期待に応え続ける。その積み重ねで、次世代の豊かな社会に繋げていく。」という経営理念のもと、ステークホルダーの方々へ最大限の貢献を行なうため、お客様との良好な関係の維持に努めております。<br />
				そのため、万一、お客様から社会通念上相当でない要求等があり、当社従業員に対する人権侵害や深刻な健康被害等を及ぼしかねない状況が発生した場合を想定し、本基本方針を定めました。
			</p>
			<ol>
				<li>
					<strong>カスタマーハラスメントの定義</strong>
					<p>当社ではカスタマーハラスメントを以下のとおり定義いたします。</p>
					<p>
						お客様からのクレーム、言動のうち、要求内容の妥当性が認められないもの、またはその妥当性に照らして、当該要求を実現するための手段・態様が社会通念上不相当なものであり、当該手段・態様により、当社従業員の心身の安全や健康、就業環境が害されるおそれがあるもの
					</p>
				</li>
				<li>
					<strong>カスタマーハラスメントの具体例</strong>
					<ul>
						<li>暴行などの身体的な攻撃</li>
						<li>人格を否定する発言、差別的な言動、性的な言動</li>
						<li>脅迫的な言動、威圧的な言動</li>
						<li>過剰または不合理な金銭補償、特別対応の要求</li>
						<li>土下座の要求、責任者による謝罪の要求、従業員の処分の要求</li>
						<li>長時間の電話、業務時間外での繰り返しの電話、会社での長時間の居座り、監禁</li>
						<li>会話を録音等してSNS等に公開するとの主張</li>
						<li>従業員への誹謗中傷、つきまとい等の従業員個人への攻撃</li>
					</ul>
					<p>※上記の記載はあくまで事例として挙げたものであり、これらに限定されません。</p>
				</li>
				<li>
					<strong>カスタマーハラスメントが発生した場合の対応</strong>
					<ul>
						<li>カスタマーハラスメントとみられる事案が発生した場合、慎重に検証いたします。</li>
						<li>カスタマーハラスメントに該当すると判断した場合は、お客様対応をお断りさせていただきます。また、カスタマーハラスメントが継続する場合、警察または弁護士等と連携し、適切に対処するとともに、お客様との契約、お客様へのサービス提供を停止、終了するなどの対応を取らせていただく場合があります。</li>
					</ul>
				</li>
				<li>
					<strong>カスタマーハラスメントへの取組み</strong>
					<ul>
						<li>カスタマーハラスメントへの対応方法を策定します。</li>
						<li>従業員に対してカスタマーハラスメントに関する知識、対処方法の教育・研修を実施します。</li>
						<li>相談・報告体制を整備します。</li>
					</ul>
				</li>
				<li>
					<strong>お客様へのお願い</strong>
					<p>
						万一、お客様にカスタマーハラスメントに該当する行為があった場合、当社は本基本方針に基づいて対応いたします。お客様におかれましてはご理解のほどお願い申し上げます。
					</p>
				</li>
			</ol>
			<hr className="dots-hr" />
			<p className="text-right mt-5">
				2026年10月1日<br />
				株式会社グローバルワイズ
			</p>
		</LayoutExtra>
	)
}

export default CustomerHarassment
